// Tiny formatting/parsing helpers shared by the UI.

/** Format a number as money with the current currency symbol. */
export function formatMoney(value: number, currency: string): string {
  const sign = value < 0 ? "-" : "";
  return `${sign}${currency}${Math.abs(value).toFixed(2)}`;
}

/** Parse whatever the user typed into a number, tolerating commas and symbols.
 *  Empty input becomes null. */
export function parseNumberInput(raw: string): number | null {
  const cleaned = raw.replace(/[^\d.,-]/g, "").replace(",", ".").trim();
  if (cleaned === "" || cleaned === "-" || cleaned === ".") return null;
  const value = Number(cleaned);
  return Number.isFinite(value) ? value : null;
}
